import { Icon } from '../c-icon/class/icon'
import { NotificationDefaultColor } from '../../enums/checkbox-default-color.enum'

/**
 * Defines the properties of a checkbox
 */
export class Checkbox {
  constructor(props: Checkbox) {
    this.iconDisabled = props.iconDisabled
    this.iconEnabled = props.iconEnabled
    this.label = props.label
    this.iconEnabledColor = props.iconEnabledColor
    this.textEnabledColor = props.textEnabledColor
    this.iconDisabledColor = props.iconDisabledColor
    this.textDisabledColor = props.textDisabledColor
    this.required = props.required
    this.name = props.name
  }
  /**
   * Icon used for disabled state
   */
  iconDisabled?: Icon
  /**
   * Icon used for enabled state
   */
  iconEnabled?: Icon
  /**
   * Name used for validation error if needed
   */
  name: string = ''
  /**
   * Label for checkbox if required
   */
  label?: string = ''
  /**
   * css color class when checkbox is enabled
   */
  iconEnabledColor?: string = NotificationDefaultColor.IconEnabled
  /**
   * css color class when checkbox is enabled
   */
  textEnabledColor?: string = NotificationDefaultColor.TextEnabled
  /**
   * css color class when checkbox is disabled
   */
  iconDisabledColor?: string = NotificationDefaultColor.IconDisabled
  /**
   * css color class when checkbox is disabled
   */
  textDisabledColor?: string = NotificationDefaultColor.TextDisabled
  /**
   * If the checkbox is required
   */
  required?: boolean = false
}
